


























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { WorkerAnonModule } from '@/store/modules/workerAnon';
import ListUtils from '@/lib/listUtils';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import JobWorkerNotInterestedReason from '@/models/JobWorkers/JobWorkerNotInterestedReason';
import UpdateAnonWorkerJobInviteRequest from '@/models/AnonJobWorkers/UpdateAnonWorkerJobInviteRequest';
import PageNames from '@/router/PageNames';

@Component({
    name: 'WorkerBookingOfferApplyDecline'
})
export default class extends GiganautVueDialog {
  
  decision = "Interested";
  reason: JobWorkerNotInterestedReason = JobWorkerNotInterestedReason.NotLooking;

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.decision = "Interested";
    }
  }

  get loading() {
    return WorkerAnonModule.loadingDialog;
  }

  get notInterestedReasons() {
    return ListUtils.jobWorkerNotInterestedReasons();
  }
	  
  async submit() { 
     if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateAnonWorkerJobInviteRequest();
    request.interested = (this.decision === "Interested")
    if (!request.interested) {
      request.notInterestedReason = Number(this.reason);
    }
    await WorkerAnonModule.updateJobInvite(request);
    this.dialog = false;
    if (WorkerAnonModule.isError) {
       this.$router.push({ name: PageNames.WorkerError });
    }
  }
}
